import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
import { isBrowser } from '@snack-uikit/utils';
import { DEFAULT, POST_MESSAGE_KEY } from '../constants/environment';
import { tryParseJson } from '../helpers/tryParseJson';
import { getCustomStore } from './private/getCustomStore';
export var useTheme = function useTheme() {
  var store = getCustomStore();
  var _useState = useState(store.theme || DEFAULT.THEME),
    _useState2 = _slicedToArray(_useState, 2),
    theme = _useState2[0],
    setTheme = _useState2[1];
  useEffect(function () {
    var receiveChangeThemeDoneMessage = function receiveChangeThemeDoneMessage(event) {
      var eventData = tryParseJson(event.data);
      if (eventData.key !== POST_MESSAGE_KEY.changeThemeDone) return;
      setTheme(eventData.value);
    };
    window.addEventListener('message', receiveChangeThemeDoneMessage, false);
    return function () {
      return window.removeEventListener('message', receiveChangeThemeDoneMessage, false);
    };
  }, []);
  var changeTheme = useCallback(function (theme) {
    isBrowser() && window.postMessage(JSON.stringify({
      key: POST_MESSAGE_KEY.changeTheme,
      value: theme
    }), location.origin);
  }, []);
  return {
    theme: theme,
    changeTheme: changeTheme
  };
};